import React, { useState, useRef, useEffect } from "react";
import {
	GridComponent,
	ColumnDirective,
	ColumnsDirective,
	Page,
	Inject,
	Resize,
	Edit,
	CommandColumn,
	ForeignKey,
	Filter,
	Toolbar,
	ExcelExport,
	Sort,
} from "@syncfusion/ej2-react-grids";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { cicassService } from "../../../../_services";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/system";
import AttendanceReportCardView from "./AttendanceReportCardView";
import { config } from "_helpers";

const filterSettings = { type: "CheckBox" }; // Menu, Excel
const toolbarOptions = [
	"Search",
	"ExcelExport",
	"Print",
	{
		text: "Refresh",
		tooltipText: "Refresh",
		prefixIcon: "e-MT_reload",
		id: "forceRefresh",
	},
];
const apiEndpointAttendanceReport = "attendance/report";
const apiEndpointGetAllUsers = "authlogin";

const AttendanceReportGrid = (props) => {
	const { isVisible, selectedYear, searchEnabled , loggedUserId, onSearchChange} = props;
	const gridRef = useRef(null);
	const toastRef = useRef(null);
	const { t } = useTranslation();
	const isMobile = window.innerWidth < config.mobileSizeCheck;
	const [attendanceReports, setAttendanceReports] = useState(null);
	const [users, setUsers] = useState(null);
	const [toast, setToast] = useState({
		message: "",
		severity: "",
		cssClass: "",
		icon: "",
	});

	useEffect(() => {
		fetchUsersAndData();
	}, [selectedYear]);

	async function fetchUsersAndData() {
		try {
			const { data: usersData } = await cicassService.getAll(apiEndpointGetAllUsers);
			const safeUsers = usersData || [];
			const sortedUsers = [...safeUsers].sort((a, b) => a.name.localeCompare(b.name));
			setUsers(sortedUsers);

			const usersMap = new Map(sortedUsers.map(u => [u.id, u.name]));
			const { data: reports } = await cicassService.getAll(`${apiEndpointAttendanceReport}/${selectedYear}`);
			const safeReports = reports || [];
			const enrichedReports = safeReports.map(r => ({
				...r,
				userName: usersMap.get(r.anaUserId) || '???'
			}));
			setAttendanceReports(enrichedReports);
		}
		catch (error) {
        	console.error("Errore nel recupero dati:", error);
			setAttendanceReports([]); // In caso di errore, resetta a array vuoto per non crashare la UI
		}
	}

	function toolbarClick(args) {
		const gridId = gridRef.current.htmlattributes.id;
		switch (args.item.properties.id) {
			case `${gridId}_excelexport`:
				gridRef.current.excelExport();
				break;
			default:
				break;
		}
		if (args.item.id === "forceRefresh") {
			fetchUsersAndData();
		}
	}

	return (
		<Box>
			{attendanceReports && isVisible && users && (
				<>
					{/* 📱 MOBILE: Card View */}
					{isMobile && (
						<AttendanceReportCardView data={attendanceReports} t={t} loggedUserId={loggedUserId} searchEnabled={searchEnabled} onSearchChange={onSearchChange}/>
					)}
					
					{/* 🖥️ DESKTOP: Syncfusion Grid */}
					{!isMobile && (
				
						<GridComponent
							id={"attendanceReportGrid"}
							ref={(g) => (gridRef.current = g)}
							dataSource={attendanceReports}
							toolbar={toolbarOptions}
							allowResizing={true}
							allowFiltering={true}
							filterSettings={filterSettings}
							allowSorting={true}
							pageSettings={{ pageSize: 30 }}
							allowExcelExport={true}
							locale={localStorage.getItem("weblang")}
							onToolbarClick={toolbarClick}
						>
							<ColumnsDirective>
								<ColumnDirective
									field="userName"
									headerText={t("name")}
									allowEditing={false}
									width="150"
								/>
								<ColumnDirective
									field="hhmmss"
									headerText={t("totalTimeSpent")}
									allowEditing={false}
									width="90"
								/>
								<ColumnDirective
									field="hHmmss_Learn"
									headerText={t("totalTimeSpentLearn")}
									allowEditing={false}
									width="90"
									visible={false}
								/>
							</ColumnsDirective>
							<Inject
								services={[
									Resize,
									Sort,
									Filter,
									Page,
									Toolbar,
									Edit,
									CommandColumn,
									ForeignKey,
									ExcelExport,
								]}
							/>
						</GridComponent>)}
				</>
			)}
			<ToastComponent
				id="toast_default"
				ref={toastRef}
				position={{ X: "Right", Y: "Bottom" }}
				title={toast.title}
				content={toast.content}
				cssClass={toast.cssClass}
				icon={toast.icon}
			/>
		</Box>
	);
};

export default AttendanceReportGrid;
